@charset "UTF-8";

/* app/js/src/components/clipping-studio/panels/find-clip-panel/clipping-studio-find-clip-panel.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.find-clip-panel__prompts::-webkit-scrollbar,
.find-clip-panel__body::-webkit-scrollbar {
  height: 11px;
  overflow: visible;
  width: 11px;
  opacity: 1;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.find-clip-panel__prompts::-webkit-scrollbar-button,
.find-clip-panel__body::-webkit-scrollbar-button {
  height: 0;
  width: 0;
}
.find-clip-panel__prompts::-webkit-scrollbar-corner,
.find-clip-panel__body::-webkit-scrollbar-corner {
  background: transparent;
}
.find-clip-panel__prompts::-webkit-scrollbar-thumb:hover,
.find-clip-panel__body::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
.find-clip-panel__prompts::-webkit-scrollbar-thumb,
.find-clip-panel__body::-webkit-scrollbar-thumb {
  background-color: #e3e6ea;
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
  min-height: 28px;
  padding: 100px 0 0;
  border-radius: 10px;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.find-clip-panel__prompts::-webkit-scrollbar-thumb:hover,
.find-clip-panel__body::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
.find-clip-panel__prompts::-webkit-scrollbar-track:hover,
.find-clip-panel__body::-webkit-scrollbar-track:hover {
  background-color: #eef2f6;
}
.find-clip-panel__prompts::-webkit-scrollbar-track,
.find-clip-panel__body::-webkit-scrollbar-track {
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
}
.find-clip-panel {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  font-family: "Open Sans", sans-serif;
}
.find-clip-panel__header {
  display: flex;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid rgb(226, 232, 241);
  flex-shrink: 0;
}
.find-clip-panel__title {
  font-size: 18px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.85);
  margin: 0;
}
.find-clip-panel__body {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.find-clip-panel__section {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.find-clip-panel__section-label {
  display: block;
  font-size: 10px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.35);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
.find-clip-panel__no-video {
  padding: 12px 0;
}
.find-clip-panel__no-video-text {
  margin: 0;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.54);
}
.find-clip-panel__error {
  padding: 12px 0;
}
.find-clip-panel__error-text {
  margin: 0;
  font-size: 14px;
  color: #ef5350;
}
.find-clip-panel__loading {
  margin: 0;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.35);
}
.find-clip-panel__empty-hint {
  margin: 0;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.35);
  font-style: italic;
}
.find-clip-panel__textarea {
  width: 100%;
  min-height: 128px;
  padding: 10px 12px;
  font-family: "Open Sans", sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.4;
  color: rgba(0, 0, 0, 0.85);
  background-color: rgb(255, 255, 255);
  border: 1px solid rgba(0, 0, 0, 0.14);
  border-radius: 6px;
  box-sizing: border-box;
  outline: none;
  resize: none;
}
.find-clip-panel__textarea:focus {
  outline: none;
  border-color: rgb(22, 177, 255);
}
.find-clip-panel__textarea::placeholder {
  color: rgba(0, 0, 0, 0.54);
}
.find-clip-panel__prompts {
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-height: 150px;
  overflow-y: auto;
}
.find-clip-panel__prompt-btn {
  text-align: left;
  padding: 8px;
  border-radius: 6px;
  background: rgb(235, 240, 244);
  border: 1px solid rgb(226, 232, 241);
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
}
.find-clip-panel__prompt-btn:hover {
  background: rgb(190, 233, 255);
  border-color: rgba(22, 177, 255, 0.5);
}
.find-clip-panel__prompt-text {
  font-size: 11px;
  color: rgba(0, 0, 0, 0.54);
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.4;
}
.find-clip-panel__prompt-btn:hover .find-clip-panel__prompt-text {
  color: rgb(22, 177, 255);
}
.find-clip-panel__dropdown {
  width: 100% !important;
  min-width: 0;
  max-width: 100%;
  display: block;
  border-radius: 6px;
}
.find-clip-panel__actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.find-clip-panel__btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  border: none;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  cursor: pointer;
  transition: background-color 0.2s ease, opacity 0.15s ease;
  box-sizing: border-box;
}
.find-clip-panel__btn:focus {
  outline: none;
  box-shadow: none;
}
.find-clip-panel__btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.find-clip-panel__btn--primary {
  padding: 8px 16px;
  height: 44px;
  border-radius: 6px;
  color: rgb(255, 255, 255);
  background-color: rgb(45, 187, 252);
}
.find-clip-panel__btn--primary:hover:not(:disabled) {
  background-color: rgb(41, 170, 229);
}
.find-clip-panel__btn--secondary {
  padding: 8px 16px;
  height: 44px;
  border-radius: 6px;
  background-color: transparent;
  border: 1px solid rgba(0, 0, 0, 0.14);
  color: rgba(0, 0, 0, 0.54);
}
.find-clip-panel__btn--secondary:hover:not(:disabled) {
  background-color: rgba(0, 0, 0, 0.04);
}
.find-clip-panel__btn--add-edit {
  height: 40px;
  background: rgb(22, 177, 255);
  color: rgb(255, 255, 255);
  border-radius: 6px;
  font-size: 12px;
}
.find-clip-panel__btn--add-edit:hover {
  background: rgb(19, 156, 224);
}
.find-clip-panel__btn--add-clip {
  height: 36px;
  background: rgb(255, 255, 255);
  border: 1px solid rgb(226, 232, 241);
  color: rgba(0, 0, 0, 0.54);
  border-radius: 6px;
  font-size: 11px;
}
.find-clip-panel__btn--add-clip:hover {
  border-color: rgba(22, 177, 255, 0.5);
  background: rgba(22, 177, 255, 0.08);
  color: rgb(22, 177, 255);
}
.find-clip-panel__spinner {
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: rgb(255, 255, 255);
  border-radius: 50%;
  animation: find-clip-spin 0.6s linear infinite;
}
.find-clip-panel__spinner--secondary {
  border-color: rgba(0, 0, 0, 0.3);
  border-top-color: rgba(0, 0, 0, 0.54);
}
@keyframes find-clip-spin {
  to {
    transform: rotate(360deg);
  }
}
.find-clip-panel__results {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-top: 16px;
}
.find-clip-panel__results-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.find-clip-panel__results-title {
  font-size: 14px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.85);
  margin: 0;
}
.find-clip-panel__clear-btn {
  font-family: "Open Sans", sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.54);
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
}
.find-clip-panel__clear-btn:hover {
  color: rgba(0, 0, 0, 0.85);
}
.find-clip-panel__edit-card {
  padding: 16px;
  background: rgb(255, 255, 255);
  border: 1px solid rgba(0, 0, 0, 0.14);
  border-radius: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.find-clip-panel__edit-card-top {
  display: flex;
  gap: 12px;
}
.find-clip-panel__edit-card-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  min-width: 48px;
  background: rgba(22, 177, 255, 0.08);
  border-radius: 0;
  color: rgb(22, 177, 255);
}
.find-clip-panel__edit-card-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.find-clip-panel__edit-card-title {
  font-size: 13px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.85);
  margin: 0;
  line-height: 1.3;
}
.find-clip-panel__edit-card-meta {
  font-size: 12px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.35);
  margin: 0;
}
.find-clip-panel__clip-card {
  padding: 12px;
  background: rgb(235, 240, 244);
  border: 1px solid rgb(226, 232, 241);
  border-radius: 0;
  transition: border-color 0.15s ease, background 0.15s ease;
}
.find-clip-panel__clip-card:hover {
  border-color: rgba(22, 177, 255, 0.5);
  background: rgb(255, 255, 255);
}
.find-clip-panel__clip-thumbnail {
  aspect-ratio: 16/9;
  background: rgba(35, 47, 58, 0.05);
  border-radius: 0;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(0, 0, 0, 0.35);
  position: relative;
  overflow: hidden;
  transition: background 0.15s ease, color 0.15s ease;
}
.find-clip-panel__clip-card:hover .find-clip-panel__clip-thumbnail {
  background: rgb(190, 233, 255);
  color: rgb(22, 177, 255);
}
.find-clip-panel__clip-confidence {
  position: absolute;
  top: 8px;
  right: 8px;
  background: #61b965;
  color: rgb(255, 255, 255);
  font-size: 10px;
  font-weight: 700;
  padding: 2px 6px;
  border-radius: 0;
}
.find-clip-panel__clip-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 12px;
}
.find-clip-panel__clip-title {
  font-size: 13px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.85);
  margin: 0;
  line-height: 1.3;
}
.find-clip-panel__clip-meta {
  font-size: 12px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.54);
  margin: 0;
}
.find-clip-panel__empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 48px 24px;
}
.find-clip-panel__empty-text {
  font-size: 13px;
  color: rgba(0, 0, 0, 0.35);
  font-style: italic;
  margin: 0;
  line-height: 1.5;
}
/*# sourceMappingURL=clipping-studio-find-clip-panel.component.css.map */
